import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <p>Copyright © 2021 Eric Tran</p>
      <a href="https://github.com/traneric89" target="_blank">
        <i className="fab fa-github"></i>
      </a>
    </footer>
  );
};

export default Footer;
